import { useMemo } from 'react'

import { getDayLabelFromIndex } from '@/intl'

import { weekDays } from '../../../weekDays'
import { form } from '../../formState'
import { useTexts } from '../../hooks/useTexts'

export function WeekStartsOn() {
  const texts = useTexts()

  const options = useMemo(
    () =>
      Object.entries(weekDays).map(([value, index]) => ({
        value,
        label: getDayLabelFromIndex(index, 'long'),
      })),
    [],
  )

  return (
    <form.RadioGroup
      testId="weekStartsOn"
      data-trackid="weekStartsOn"
      options={options}
      name="weekStartsOn"
      validateOn="blur change"
      label={texts.weekStartsOn.charAt(0).toUpperCase() + texts.weekStartsOn.slice(1).toLowerCase()}
    />
  )
}
